import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VentaService } from '../../../services/venta/venta.service';
import { ConfigService } from '../../../services/config/config.service';

@Component({
  selector: 'app-recibo',
  templateUrl: './recibo.component.html',
  styleUrls: ['./recibo.component.scss'],
  standalone: false,
})
export class ReciboComponent implements OnInit {

  arrayVenta: any = {};
  subtotal: number = 0;
  impuesto: number = 0;
  descuento: number = 0;
  discImpuesto: any = [];
  title: string = "";
  setImpresion: boolean = true;
  messageDiv: string = "";
  idComprobante: number = 1;
  token: any | undefined;



  constructor(private router: ActivatedRoute,
    private venta: VentaService,
    public config: ConfigService) { }

  ngOnInit(): void {
    if (!!localStorage.getItem('token'))
      this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());

    this.router.params.subscribe(params => {
      this.idComprobante = parseInt(params["idComprobante"]) ?? 1;
      // obtener el Id
      if (!isNaN(parseInt(params["idVenta"]))) {
        this.venta.getRecibo((this.token?.token ?? ""), parseInt(params["idVenta"])).subscribe((response) => {
          if (response == null) {
            this.messageDiv = "<div class='p-message p-message-success'>NO se encuentran datos bajo esta referencia</div>";
          }
          else {
            this.arrayVenta = response as object;
            console.log(this.arrayVenta)
            //validar que sea una venta activa o una nota credito
            if ((this.arrayVenta.idVentaEstado == 3) || (this.arrayVenta.idVentaEstado == 4)) {
              // validación de fechas
              const now = new Date();
              const diff = (now.getTime() - new Date(this.arrayVenta.fechaRegistro).getTime()) / (1000 * 3600 * 24);
              if (parseInt(diff.toString()) > 0) {
                this.setImpresion = false;
              }

              if (this.arrayVenta.idVentaEstado == 4)
                this.title = "Nota de Credito"
              else
                this.title = "TICKET"
              // obtener subtotales
              this.arrayVenta.detalleVenta.forEach((element: any) => {
                this.subtotal += element.subtotal;
                this.impuesto += element.impuesto;
                this.descuento += element.descuento;

                // obtener subtotales para discmininar el IVA
                if (this.discImpuesto.length > 0) {
                  //saber si ya existe
                  let indexFilter = this.discImpuesto.findIndex((item: any) => { return item.Tipo == element.idProductoNavigation.impuesto });
                  if (indexFilter > -1) {
                    this.discImpuesto[indexFilter].Base += element.subtotal;
                    this.discImpuesto[indexFilter].Impuesto += element.impuesto;
                    this.discImpuesto[indexFilter].Venta += (element.subtotal + element.impuesto);
                  }
                  else
                    this.discImpuesto.push({
                      Tipo: element.idProductoNavigation.impuesto,
                      Base: element.subtotal,
                      Impuesto: element.impuesto,
                      Venta: element.subtotal + element.impuesto
                    })
                }
                else {
                  this.discImpuesto.push({
                    Tipo: element.idProductoNavigation.impuesto,
                    Base: element.subtotal,
                    Impuesto: element.impuesto,
                    Venta: element.subtotal + element.impuesto
                  });
                }

              });
              this.router.queryParams.subscribe((data: any) => {
                if (data.hasOwnProperty('print'))
                  if (data.print == 'YES')
                    setTimeout(() => {
                      this.setPrint();
                    }, 3000);
              })
            }

          }
        });
      }
    });
  }

  encriptar = (str: string): string => {
    return btoa(str);
  }

  setPrint() {
    window.print();
  }

}
